import cx from 'classnames';
import React, { useContext } from 'react';

import styles from './Form.module.scss';
import type { FormProps } from './Form.types';
import FormContext from './FormContext';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';

const Form = (props: FormProps) => {
  const {
    children, 
    className, 
    ...otherFormProps
  } = props;

  const formContext = useContext(FormContext);
  const { formRef, onFormSubmit, resetForm } = formContext || {};
  const variantProps = useBuildVariantProps(
    'form',
  );
  return (
    <form 
      {...otherFormProps}
      ref={formRef}
      className={cx(styles.form, className)}
      onSubmit={onFormSubmit} 
      onReset={(e) => {
        e.preventDefault();
        resetForm?.();
        props.onReset?.(e);
      }}
      {...variantProps}
    >
      {children}
    </form>
  );
};

export default Form;